import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function AepsDmtServices() {
  const bankingFaqs = [
    {
      question: "What is AEPS (Aadhaar Enabled Payment System) at Mokshiq?",
      answer: "AEPS allows customers to perform basic banking transactions like Cash Withdrawal, Balance Inquiry, Mini Statement, and Aadhaar Pay at any retail outlet using only their Aadhaar number and fingerprint biometric authentication."
    },
    {
      question: "How fast are DMT (Direct Money Transfer) transactions?",
      answer: "Mokshiq DMT processes domestic money remittances in real-time via 24x7 IMPS and NEFT channels to any scheduled commercial or Gramin bank in India."
    },
    {
      question: "What is the Micro ATM (mATM) solution?",
      answer: "Our mATM solution includes compact Bluetooth handheld POS devices and Android SDKs that allow local retailers to act as mini ATM counters accepting Debit/ATM cards."
    },
    {
      question: "Is 2FA (Two-Factor Authentication) enforced for AEPS transactions?",
      answer: "Yes, in compliance with NPCI security guidelines, 2FA biometric merchant daily login and transaction authorization are strictly enforced to safeguard customer funds."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        
        {/* Page Header */}
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-building-columns me-2"></i>Banking &amp; Digital Payments
            </span>
            <h1 className="page_title text-white mb-3">AEPS, DMT &amp; Banking Solutions</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Transform any retail store into a digital bank branch with AEPS cash withdrawal, instant money transfer, Micro ATM, and Aadhaar Pay (Powered by <strong>Rakle Service Private Limited</strong>).
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">AEPS &amp; Banking</a></li>
            </ul>
          </div>
        </section>

        {/* AEPS & DMT Main Features */}
        <section className="aeps_details section_space bg-light">
          <div className="container">
            <div className="row g-4 align-items-center mb-5">
              <div className="col-lg-6">
                <span className="badge px-3 py-2 text-uppercase font-weight-bold mb-2" style={{ backgroundColor: '#16a34a', color: '#ffffff' }}>Aadhaar Banking</span>
                <h2 className="heading_text font-weight-bold" style={{ color: '#0f172a' }}>AEPS &amp; Aadhaar Pay Suite</h2>
                <p className="mb-4 font-weight-bold" style={{ color: '#334155', fontSize: '1rem', lineHeight: '1.6' }}>
                  Mokshiq AEPS empowers rural and urban retailers to deliver essential banking services to millions of citizens using NPCI-certified fingerprint biometrics.
                </p>
                
                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="p-3 bg-white rounded-4 border shadow-sm h-100">
                      <div className="font-weight-bold mb-1" style={{ color: '#16a34a', fontSize: '1rem' }}>
                        <i className="fa-solid fa-hand-holding-dollar me-2"></i>Cash Withdrawal
                      </div>
                      <div className="small font-weight-bold" style={{ color: '#475569' }}>Instant cash out from any Aadhaar-linked bank account.</div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="p-3 bg-white rounded-4 border shadow-sm h-100">
                      <div className="font-weight-bold mb-1" style={{ color: '#d97706', fontSize: '1rem' }}>
                        <i className="fa-solid fa-file-invoice-dollar me-2"></i>Mini Statement
                      </div>
                      <div className="small font-weight-bold" style={{ color: '#475569' }}>Fetch 10 recent transactions instantly with commission.</div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="p-3 bg-white rounded-4 border shadow-sm h-100">
                      <div className="font-weight-bold mb-1" style={{ color: '#0f172a', fontSize: '1rem' }}>
                        <i className="fa-solid fa-fingerprint me-2"></i>Aadhaar Pay
                      </div>
                      <div className="small font-weight-bold" style={{ color: '#475569' }}>Accept higher limit payments directly from bank accounts.</div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="p-3 bg-white rounded-4 border shadow-sm h-100">
                      <div className="font-weight-bold mb-1" style={{ color: '#2563eb', fontSize: '1rem' }}>
                        <i className="fa-solid fa-shield-halved me-2"></i>NPCI 2FA Secure
                      </div>
                      <div className="small font-weight-bold" style={{ color: '#475569' }}>Mandatory 2FA daily merchant biometric login protection.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="p-4 p-md-5 bg-dark text-white rounded-4 shadow-lg text-center position-relative overflow-hidden">
                  <div className="badge bg-warning text-dark px-3 py-2 mb-3 text-uppercase font-weight-bold">Highest Payout SLA</div>
                  <h3 className="font-weight-bold text-white mb-2">Earn Up To ₹13 Per AEPS Cashout</h3>
                  <p className="text-white-50 small mb-4" style={{ fontSize: '0.95rem' }}>Instant real-time wallet credit with zero pending transactions and 24x7 automated bank payouts.</p>
                  <a href="/contact_us" className="btn btn-warning text-dark font-weight-bold px-4 py-2 rounded-pill shadow">
                    Become an AEPS Agent &rarr;
                  </a>
                </div>
              </div>
            </div>

            {/* Interactive Visual Flow Diagram Section */}
            <div className="my-5 p-4 p-lg-5 bg-white rounded-4 border shadow-sm">
              <div className="text-center mb-5">
                <span className="badge px-3 py-2 text-uppercase mb-2 font-weight-bold" style={{ backgroundColor: '#0f172a', color: '#f59e0b', letterSpacing: '1px' }}>
                  <i className="fa-solid fa-diagram-project me-1"></i>BANKING ARCHITECTURE FLOW
                </span>
                <h3 className="heading_text font-weight-bold" style={{ color: '#0f172a' }}>AEPS &amp; Remittance Network Nodes</h3>
                <p className="mx-auto" style={{ maxWidth: '650px', color: '#475569' }}>
                  Central NPCI Switch integrated with 4 key retail banking channels for high-success transaction processing.
                </p>
              </div>

              <div className="row g-4 align-items-center">
                
                {/* 4-Node Banking Switch Graphic */}
                <div className="col-lg-6">
                  <div className="p-4 rounded-4 border text-center position-relative overflow-hidden" style={{ backgroundColor: '#f8fafc', minHeight: '400px', borderColor: '#e2e8f0' }}>
                    
                    <div className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle shadow-lg p-3 border" style={{ width: '130px', height: '130px', zIndex: 2, borderColor: '#16a34a' }}>
                      <i className="fa-solid fa-building-columns fa-2x mb-1 mt-2" style={{ color: '#16a34a' }}></i>
                      <div className="small font-weight-bold lh-1" style={{ color: '#0f172a' }}>AEPS Core Hub</div>
                    </div>

                    <div className="row g-3 h-100 position-relative" style={{ zIndex: 1 }}>
                      <div className="col-6 mb-4">
                        <div className="p-3 bg-white rounded-3 shadow-sm border h-100">
                          <div className="icon_box text-white mx-auto mb-2" style={{ backgroundColor: '#16a34a' }}>
                            <i className="fa-solid fa-hand-holding-dollar"></i>
                          </div>
                          <h4 className="h6 font-weight-bold mb-1" style={{ color: '#0f172a' }}>Cash Out</h4>
                          <span className="small font-weight-bold" style={{ color: '#64748b' }}>Aadhaar Biometric</span>
                        </div>
                      </div>

                      <div className="col-6 mb-4">
                        <div className="p-3 bg-white rounded-3 shadow-sm border h-100">
                          <div className="icon_box text-white mx-auto mb-2" style={{ backgroundColor: '#2563eb' }}>
                            <i className="fa-solid fa-money-bill-transfer"></i>
                          </div>
                          <h4 className="h6 font-weight-bold mb-1" style={{ color: '#0f172a' }}>DMT IMPS</h4>
                          <span className="small font-weight-bold" style={{ color: '#64748b' }}>24x7 Money Transfer</span>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="p-3 bg-white rounded-3 shadow-sm border h-100">
                          <div className="icon_box text-white mx-auto mb-2" style={{ backgroundColor: '#d97706' }}>
                            <i className="fa-solid fa-fingerprint"></i>
                          </div>
                          <h4 className="h6 font-weight-bold mb-1" style={{ color: '#0f172a' }}>Aadhaar Pay</h4>
                          <span className="small font-weight-bold" style={{ color: '#64748b' }}>Merchant Limit Pay</span>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="p-3 bg-white rounded-3 shadow-sm border h-100">
                          <div className="icon_box text-white mx-auto mb-2" style={{ backgroundColor: '#0284c7' }}>
                            <i className="fa-solid fa-credit-card"></i>
                          </div>
                          <h4 className="h6 font-weight-bold mb-1" style={{ color: '#0f172a' }}>Micro ATM</h4>
                          <span className="small font-weight-bold" style={{ color: '#64748b' }}>Debit Card POS</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Live Transaction Settlement Graphic */}
                <div className="col-lg-6">
                  <div className="p-4 rounded-4 border text-center position-relative overflow-hidden" style={{ backgroundColor: '#f8fafc', minHeight: '400px', borderColor: '#e2e8f0' }}>
                    <div className="bg-white p-4 rounded-4 border shadow-sm position-relative mx-auto" style={{ maxWidth: '340px', borderColor: '#cbd5e1' }}>
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <i className="fa-solid fa-circle-check fa-3x me-3" style={{ color: '#16a34a' }}></i>
                        <div className="text-start">
                          <div className="font-weight-bold" style={{ color: '#0f172a' }}>AEPS Cash Out</div>
                          <div className="small font-weight-bold" style={{ color: '#16a34a' }}>₹10,000 Dispensed</div>
                        </div>
                      </div>

                      <div className="p-3 rounded-3 border mb-3 text-start small" style={{ backgroundColor: '#f8fafc', borderColor: '#e2e8f0' }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="font-weight-bold" style={{ color: '#64748b' }}>Customer Bank:</span>
                          <span className="font-weight-bold" style={{ color: '#0f172a' }}>SBI / HDFC</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="font-weight-bold" style={{ color: '#64748b' }}>Agent Margin:</span>
                          <span className="badge text-white px-2 py-1" style={{ backgroundColor: '#16a34a' }}>+ ₹13.00 Commission</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="font-weight-bold" style={{ color: '#64748b' }}>RRN Number:</span>
                          <span className="font-monospace small font-weight-bold" style={{ color: '#334155' }}>#408920193</span>
                        </div>
                      </div>

                      <div className="p-2 text-white rounded-3 font-weight-bold small shadow-sm" style={{ backgroundColor: '#0f172a' }}>
                        <i className="fa-solid fa-bolt text-warning me-1"></i> Instant Wallet Settlement
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* DMT Section */}
            <div className="row g-4 align-items-center flex-row-reverse mt-4">
              <div className="col-lg-6">
                <span className="badge px-3 py-2 text-uppercase font-weight-bold mb-2" style={{ backgroundColor: '#2563eb', color: '#ffffff' }}>Domestic Remittance</span>
                <h2 className="heading_text font-weight-bold" style={{ color: '#0f172a' }}>Direct Money Transfer (DMT)</h2>
                <p className="mb-3 font-weight-bold" style={{ color: '#334155', fontSize: '1rem', lineHeight: '1.6' }}>
                  Send money instantly to any bank account across India, even on Sundays and bank holidays. Our dual-route IMPS gateway guarantees zero pending transactions.
                </p>
                <ul className="iconlist_block unordered_list_block small p-0 m-0" style={{ listStyle: 'none' }}>
                  <li className="mb-2 font-weight-bold" style={{ color: '#334155' }}><i className="fa-solid fa-circle-check me-2" style={{ color: '#2563eb' }}></i><strong>IMPS &amp; NEFT Channels:</strong> 24x7 real-time bank settlement.</li>
                  <li className="mb-2 font-weight-bold" style={{ color: '#334155' }}><i className="fa-solid fa-circle-check me-2" style={{ color: '#2563eb' }}></i><strong>Beneficiary Account Verification:</strong> Integrated Penny Drop verification before transfer.</li>
                  <li className="mb-2 font-weight-bold" style={{ color: '#334155' }}><i className="fa-solid fa-circle-check me-2" style={{ color: '#2563eb' }}></i><strong>Higher Sender Limits:</strong> Support for multiple sender registrations with OTP validation.</li>
                </ul>
              </div>
              <div className="col-lg-6">
                <div className="p-4 p-md-5 bg-white rounded-4 shadow-sm border text-center transition-all h-100 d-flex flex-column justify-content-center align-items-center">
                  <div className="icon_box bg-primary text-white mx-auto mb-3" style={{ backgroundColor: '#eff6ff', color: '#2563eb' }}>
                    <i className="fa-solid fa-money-bill-transfer" style={{ color: '#2563eb' }}></i>
                  </div>
                  <h4 className="font-weight-bold mb-2" style={{ color: '#0f172a' }}>24x7 Instant Money Transfer</h4>
                  <p className="small mb-4 font-weight-bold" style={{ color: '#64748b', maxWidth: '340px' }}>Seamless integration via web portal, mobile apps, or B2B REST APIs.</p>
                  <a href="tel:+917311104571" className="btn btn-custom-blue font-weight-bold px-4 py-3 rounded-pill shadow-sm d-inline-flex align-items-center justify-content-center">
                    <i className="fa-solid fa-phone-volume me-2"></i>Contact Sales (+91 7311104571)
                  </a>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* FAQ Section */}
        <FAQ 
          faqList={bankingFaqs} 
          title="AEPS &amp; Banking FAQs" 
          subtitle="Learn more about operational procedures, commissions, and compliance standards." 
        />

      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default AepsDmtServices;
